/** Prefijo Venezuela (fijo en registro comensal). */
export const PHONE_PREFIX_VE = '+58';

const DIGITS_ONLY = /\D/g;

/** Construye E.164 +58… a partir solo de los dígitos nacionales (sin prefijo). */
export function phoneE164Venezuela(nationalDigits: string): string {
  const d = nationalDigits.replace(DIGITS_ONLY, '');
  if (!d) return PHONE_PREFIX_VE;
  return `${PHONE_PREFIX_VE}${d}`;
}

/**
 * Venezuela: normalmente 10 dígitos nacionales (p. ej. 4141234567).
 */
export function isValidVenezuelaNational(nationalRaw: string): boolean {
  const d = nationalRaw.replace(DIGITS_ONLY, '');
  return d.length === 10 && /^[1-9]\d{9}$/.test(d);
}

/** @deprecated Usar phoneE164Venezuela / isValidVenezuelaNational en registro VE. */
export function normalizePhoneE164(raw: string): string {
  const trimmed = raw.replace(/\s/g, '');
  if (!trimmed) return '';
  if (trimmed.startsWith(PHONE_PREFIX_VE)) {
    return `${PHONE_PREFIX_VE}${trimmed.slice(PHONE_PREFIX_VE.length).replace(DIGITS_ONLY, '')}`;
  }
  if (trimmed.startsWith('+')) {
    const digits = trimmed.replace(/^\+/, '').replace(DIGITS_ONLY, '');
    return `+${digits}`;
  }
  const digits = trimmed.replace(DIGITS_ONLY, '');
  return phoneE164Venezuela(digits);
}

/** @deprecated */
export function isValidPhoneInput(raw: string): boolean {
  return isValidVenezuelaNational(raw);
}
